import {
  BOOKING_PROCESS_START,
  BOOKING_PROCESS_SUCCESS,
  BOOKING_PROCESS_ERROR,
  GET_SERVICE_FEES_SUCCESS,
  BOOKING_PAYMENT_START,
  BOOKING_PAYMENT_SUCCESS,
  BOOKING_PAYMENT_ERROR,
  BOOKING_PAYMENT_FOR_CANCEL_START,
  BOOKING_PAYMENT_FOR_CANCEL_ERROR,
  VALIDATE_PROMO_CODE_SUCCESS,
  VALIDATE_PROMO_CODE_ERROR,
  VALIDATE_PROMO_CODE_START
} from '../constants';

export default function book(state = {}, action) {
  switch (action.type) {

    case BOOKING_PROCESS_START:
      return {
        ...state,
        data: null,
        bookDetails: null,
        bookingLoading: action.payload.bookingLoading,
      };

    case BOOKING_PROCESS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        bookDetails: action.payload.bookDetails,
        bookingLoading: action.payload.bookingLoading,
      };

    case BOOKING_PROCESS_ERROR:
      return {
        ...state,
        bookingLoading: action.payload.bookingLoading,
      };

    case BOOKING_PAYMENT_START:
      return {
        ...state,
        paymentLoading: action.payload.paymentLoading,
      };

    case BOOKING_PAYMENT_SUCCESS:
      return {
        ...state,
        paymentLoading: action.payload.paymentLoading,
      };

    case BOOKING_PAYMENT_ERROR:
      return {
        ...state,
        paymentLoading: action.payload.paymentLoading,
      };

    case BOOKING_PAYMENT_FOR_CANCEL_START:
      return {
        ...state,
        paymentLoading: action.payload.paymentLoading,
      };

    case BOOKING_PAYMENT_FOR_CANCEL_ERROR:
      return {
        ...state,
        paymentLoading: action.payload.paymentLoading,
      };

    case GET_SERVICE_FEES_SUCCESS:
      return {
        ...state,
        serviceFees: action.payload.serviceFees,
      };

    case VALIDATE_PROMO_CODE_START:
      return {
        ...state,
        validPromoCode: action?.payload?.validPromoCode,
        promoCodeLoading: action?.payload?.promoCodeLoading
      };

    case VALIDATE_PROMO_CODE_SUCCESS:
      return {
        ...state,
        validPromoCode: action?.payload?.validPromoCode,
        promoCodeLoading: action?.payload?.promoCodeLoading
      };

    case VALIDATE_PROMO_CODE_ERROR:
      return {
        ...state,
        validPromoCode: action?.payload?.validPromoCode,
        promoCodeLoading: action?.payload?.promoCodeLoading
      };

    default:
      return state;
  }
}